import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { Lesson } from '@lyceo/shared/plan/util-models';
import { LessonActions } from './lesson.actions';
import { AuthActions } from '@lyceo/shared/auth/data-access';
import { PupilContextActions } from '@lyceo/shared/pupil-context/data-access';
import { mapLesson } from './lesson.functions';

export const LESSON_FEATURE_KEY: string = 'planLesson';

//eslint-disable-next-line
export interface LessonState extends EntityState<Lesson> {}

export const lessonAdapter: EntityAdapter<Lesson> =
  createEntityAdapter<Lesson>();

export const initialLessonState: LessonState = lessonAdapter.getInitialState(
  {},
);

const reducer: ActionReducer<LessonState, Action> = createReducer(
  initialLessonState,
  on(
    AuthActions.logoutSuccess,
    PupilContextActions.setPupilContext,
    (): LessonState => initialLessonState,
  ),
  on(
    LessonActions.getLessonsByDaySuccess,
    (state, action): LessonState =>
      lessonAdapter.upsertMany(
        action.lessons.map((lessonDto) => mapLesson(lessonDto)),
        {
          ...state,
        },
      ),
  ),
);

export function lessonReducer(
  state: LessonState | undefined,
  action: Action,
): LessonState {
  return reducer(state, action);
}
